import { useEffect, useRef, useState } from "react";
import "./BackgroundMusic.css";

export default function BackgroundMusic() {
  const audioRef = useRef(null);
  const [isOn, setIsOn] = useState(true);
  const [showVoiceNote, setShowVoiceNote] = useState(false);
  const [showGlowHint, setShowGlowHint] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("exploreLankaMusicOn");
    setIsOn(saved === null ? true : saved === "true");
  }, []);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const shouldPauseForLanguages =
      localStorage.getItem("exploreLankaPauseMusicForVoice") === "true";

    const alreadyAcknowledged =
      sessionStorage.getItem("exploreLankaVoiceHintSeen") === "true";
    
    if (shouldPauseForLanguages && !alreadyAcknowledged) {
      setShowGlowHint(true);
    }

      if (shouldPauseForLanguages) {
        setShowVoiceNote(true);
      
        clearTimeout(window.voiceNoteTimeout);
        window.voiceNoteTimeout = setTimeout(() => {
          setShowVoiceNote(false);
        }, 2500);
      } else {
        setShowVoiceNote(false);
      }


    if (isOn && !shouldPauseForLanguages) {
      audio.volume = 0.35;
      audio.play().catch(() => {});
    } else {
      audio.pause();
    }

    localStorage.setItem("exploreLankaMusicOn", String(isOn));
  }, [isOn]);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const syncPlayback = () => {
      const savedOn = localStorage.getItem("exploreLankaMusicOn");
      const shouldBeOn = savedOn === null ? true : savedOn === "true";
      const shouldPauseForLanguages =
        localStorage.getItem("exploreLankaPauseMusicForVoice") === "true";

      setIsOn(shouldBeOn);

      if (shouldBeOn && !shouldPauseForLanguages) {
        audio.volume = 0.35;
        audio.play().catch(() => {});
      } else {
        audio.pause();
      }
    };

    window.addEventListener("storage", syncPlayback);
    window.addEventListener("focus", syncPlayback);
    window.addEventListener("pageshow", syncPlayback);
    window.addEventListener("click", syncPlayback, { passive: true });

    return () => {
      window.removeEventListener("storage", syncPlayback);
      window.removeEventListener("focus", syncPlayback);
      window.removeEventListener("pageshow", syncPlayback);
      window.removeEventListener("click", syncPlayback);
    };
  }, []);

  function handleToggle() {
  const next = !isOn;
  setIsOn(next);
  localStorage.setItem("exploreLankaMusicOn", String(next));

  if (showGlowHint) {
    setShowGlowHint(false);
    sessionStorage.setItem("exploreLankaVoiceHintSeen", "true");
  }
}

  return (
    <>
      <audio
        ref={audioRef}
        src="/audio/exploreLankaAudio.mp3"
        loop
        preload="auto"
      />

      <button
        type="button"
        className={`musicToggle ${showGlowHint ? "voicePausedGlow" : ""}`}
        onClick={handleToggle}
        aria-label={isOn ? "Turn music off" : "Turn music on"}
        title={isOn ? "Turn music off" : "Turn music on"}
      >
        {isOn ? (
          <svg width="20" height="20" viewBox="0 0 64 64" fill="#ffffff">
            <path d="M59.998,28.001h-7.999c-2.211,0-4,1.789-4,4s1.789,4,4,4h7.999c2.211,0,4-1.789,4-4S62.209,28.001,59.998,28.001z"/>
            <path d="M49.71,19.466l6.929-4c1.914-1.105,2.57-3.551,1.461-5.465c-1.102-1.914-3.547-2.57-5.46-1.465l-6.93,4c-1.914,1.105-2.57,3.551-1.461,5.464C45.351,19.915,47.796,20.571,49.71,19.466z"/>
            <path d="M56.639,48.535l-6.929-3.999c-1.914-1.105-4.355-0.449-5.461,1.464c-1.105,1.914-0.453,4.359,1.461,5.465l6.93,4c1.913,1.105,4.358,0.449,5.464-1.465S58.553,49.641,56.639,48.535z"/>
            <path d="M37.53,0.307c-1.492-0.625-3.211-0.277-4.359,0.867L18.343,16.001H4c-2.211,0-4,1.789-4,4v24C0,46.211,1.789,48,4,48h14.343l14.828,14.828C33.937,63.594,34.96,64,35.999,64c0.516,0,1.035-0.098,1.531-0.305c1.496-0.617,2.469-2.078,2.469-3.695V4.001C39.999,2.384,39.026,0.924,37.53,0.307z"/>
          </svg>
        ) : (
          <svg width="20" height="20" viewBox="0 0 64 64" fill="#ffffff">
            <path d="M59.998,28.001h-7.999c-2.211,0-4,1.789-4,4s1.789,4,4,4h7.999c2.211,0,4-1.789,4-4S62.209,28.001,59.998,28.001z"/>
            <path d="M49.71,19.466l6.929-4c1.914-1.105,2.57-3.551,1.461-5.465c-1.102-1.914-3.547-2.57-5.46-1.465l-6.93,4c-1.914,1.105-2.57,3.551-1.461,5.464C45.351,19.915,47.796,20.571,49.71,19.466z"/>
            <path d="M56.639,48.535l-6.929-3.999c-1.914-1.105-4.355-0.449-5.461,1.464c-1.105,1.914-0.453,4.359,1.461,5.465l6.93,4c1.913,1.105,4.358,0.449,5.464-1.465S58.553,49.641,56.639,48.535z"/>
            <path d="M37.53,0.307c-1.492-0.625-3.211-0.277-4.359,0.867L18.343,16.001H4c-2.211,0-4,1.789-4,4v24C0,46.211,1.789,48,4,48h14.343l14.828,14.828C33.937,63.594,34.96,64,35.999,64c0.516,0,1.035-0.098,1.531-0.305c1.496-0.617,2.469-2.078,2.469-3.695V4.001C39.999,2.384,39.026,0.924,37.53,0.307z"/>
            <line x1="8" y1="8" x2="56" y2="56" stroke="red" strokeWidth="8" strokeLinecap="round" />
          </svg>
        )}
      </button>

      {showVoiceNote && (
        <div className="musicVoiceNote">
          The music has been paused so you can hear the words!
        </div>
      )}
    </>
  );
}